import * as api from './AppointmentApi';
import { messages } from '../../lang/en';
import { getFullWeek } from '../../utils/dateTimeUtil';
import * as type from './AppointmentType';
import { getNamespace } from '../../utils/storage';
import { bodyReq } from '../../utils/bodyRequest';

export const getAdmissionDetail = (id) => async (dispatch) => {
    dispatch({
        type: type.SET_SELECTED_ADMISSION.REQUEST
    });
    const namespace = getNamespace();
    return await api.getAdmissionDetail(id, namespace).then((response) => {
        if (response) {
            dispatch({
                type: type.SET_SELECTED_ADMISSION.SUCCESS,
                payload: response.data
            });
        }
    });
};
export const editAdmission = (id, admission) => async (dispatch) => {
    const body = bodyReq(admission);
    return await api.editAdmission(id, body).then((response) => {
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.admissionEditSuccess,
                status: response.status
            }
        });
    });
};
export const setSelectedAdmission = (admission) => (dispatch) => {
    dispatch({
        type: type.SET_SELECTED_ADMISSION,
        payload: admission
    });
};
export const getAppointments = (clinicId, date) => async (dispatch) => {
    dispatch({
        type: type.GET_APPOINTMENTS.REQUEST
    });
    const namespace = getNamespace();
    return await api.getAppointments(clinicId, date, null, namespace).then((response) => {
        dispatch({
            type: type.GET_APPOINTMENTS.SUCCESS,
            payload: response.data?.appointments
        });
    });
};
export const getPatientAppointments = (clinicId, patientId) => async (dispatch) => {
    dispatch({
        type: type.GET_PATIENT_APPOINTMENTS.REQUEST
    });
    const namespace = getNamespace();
    return await api.getAppointments(clinicId, null, patientId, namespace).then((response) => {
        dispatch({
            type: type.GET_PATIENT_APPOINTMENTS.SUCCESS,
            payload: response.data?.appointments
        });
    });
};
export const reorderAppointment = (appointmentId, position, prevId) => async () => {
    const namespace = getNamespace();
    return await api
        .reorderAppointments(appointmentId, position, prevId, namespace)
        .then((response) => {
            return response;
        });
};
export const changeStateOfAppointment =
    (appointmentId, state, position, admission) => async (dispatch) => {
        const namespace = getNamespace();
        let param;
        if (admission) {
            param = {
                state,
                position,
                admission,
                namespace
            };
        } else {
            param = {
                state,
                position,
                namespace
            };
        }
        return await api.changeStateOfAppointment(appointmentId, param).then((response) => {
            if (admission) {
                dispatch({
                    type: type.CHANGE_APPOINTMENT_STATUS,
                    payload: response.data
                });
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: messages.postActionAlert.admissionSubmitSuccess,
                        status: response.status
                    }
                });
            } else {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: messages.postActionAlert.appointmentStatus,
                        status: response.status
                    }
                });
            }
            return response;
        });
    };
export const createAppointment = (appointment) => async (dispatch) => {
    const body = bodyReq(appointment);
    return await api.createAppointment(body).then((response) => {
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.appointmentSubmitted,
                status: response.status
            }
        });
        dispatch({
            type: type.ADD_PATIENT_APPOINTMENT,
            payload: response.data
        });
        dispatch({
            type: type.ADD_APPOINTMENT,
            payload: response.data
        });

        return response;
    });
};
export const changeAppointmentSignal = (data) => (dispatch) => {
    dispatch({
        type: type.CHANGE_APPOINTMENT_SIGNAL,
        payload: data
    });
};
export const deleteAppointmentSignal = (data) => (dispatch) => {
    dispatch({
        type: type.DELETE_APPOINTMENT_SIGNAL,
        payload: data.id
    });
};
export const toggleForceReload = (forceReload) => (dispatch) => {
    dispatch({
        type: type.TOGGLE_FORCE_RELOAD,
        payload: forceReload
    });
};
export const deleteAppointment = (id) => async (dispatch) => {
    const namespace = getNamespace();
    return await api.deleteAppointment(id, namespace).then((response) => {
        dispatch({
            type: type.REMOVE_PATIENT_APPOINTMENT,
            payload: id
        });
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.appointmentDeleted,
                status: response.status
            }
        });
    });
};
export const editAppointment = (id, appointment) => async (dispatch) => {
    const body = bodyReq(appointment);
    return await api.editAppointment(id, body).then((response) => {
        dispatch({
            type: type.EDIT_PATIENT_APPOINTMENT,
            payload: response.data
        });
        dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: messages.postActionAlert.appointmentEdited,
                status: response.status
            }
        });
        return response;
    });
};
export const getAppointmentDetail = (id) => async (dispatch) => {
    const namespace = getNamespace();
    return await api.getAppointmentDetail(id, namespace).then((appointment) => {
        if (appointment) {
            dispatch({
                type: type.SET_SELECTED_APPOINTMENT,
                payload: appointment
            });
        }
    });
};
export const setSelectedAppointment = (appointment) => (dispatch) => {
    dispatch({
        type: type.SET_SELECTED_APPOINTMENT,
        payload: appointment
    });
};
export const setEditedAppointment = (appointment) => (dispatch) => {
    dispatch({
        type: type.SET_EDITED_APPOINTMENT,
        payload: appointment
    });
};
export const resetAppointmentEditRelatedStates = () => async (dispatch) => {
    await dispatch(setEditedAppointment(null));
    await dispatch(setSelectedAppointment(null));
    await dispatch(setSelectedAdmission(null));
};
export const setHour = (hour) => (dispatch) => {
    if (!hour) {
        return;
    }
    dispatch({
        type: type.SET_HOUR,
        payload: hour
    });
};
export const setDate = (date) => (dispatch) => {
    if (!date) {
        return;
    }
    dispatch({
        type: type.SET_DATE,
        payload: date
    });
};
export const setWeek = (date) => async (dispatch) => {
    const week = getFullWeek(date);
    await dispatch({
        type: type.SET_WEEK,
        payload: week
    });
};
